import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import toast from "react-hot-toast";

/**
 * Log a warning and show a toast!
 */
export const errorLoggingMiddleware: Middleware =
  () => (next) => (action: any) => {
    if (isRejectedWithValue(action)) {
      //notificationController.error({ message: action.payload });
      toast.error(action.payload, {
        style: {
          border: "1px solid #ff3b6b",
          padding: "16px",
          color: "#ff3b6b",
          fontSize: "16px",
        },
        iconTheme: {
          primary: "#ff3b6b",
          secondary: "#FFFAEE",
        },
      });
      console.log(action.payload);
    }

    return next(action);
  };
